import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Drawer from 'react-modern-drawer';
import TransactionServices from "./TransactionServices";

export default function UploadedFileBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [fileHistory, setFileHistory] = useState<any[]>([]);
        const fileUpload = () => {
            var payload = {year: '', month: '', territory: '', pageNumber: 1, pageSize: 10}
            TransactionServices.fileHistory(payload).then((res) => {
                console.log(res)
                fileHistory = res
                setFileHistory(res)
            })
        }
    
    useEffect(() => {
        fileUpload()
    }, [param.param])

    const onClose = () => {
        param.UploadedFileClose();
    }

    return (
        <Drawer open={openFirst}
            onClose={onClose}
            direction='right'
            className='react-drawer allowHscroll'
            size={1200}>
            <div className="ws-6">
                <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >\
                    <div className="box mb">
                        <div className="box mb">
                            <div className="box-header-main">
                                <h2 className="ws-12 m0 pl full-width"> Uploaded File</h2>
                            </div>
                            <div className="box-content">
                                <div className="row-fluid">
                                    <form  >
                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label">Date</label>
                                                <div className="label-entries">
                                                    <input type="text" placeholder="Select month and year"  data-ng-click="open($event,'searchDatehistory')"  data-ng-model="searchDatehistory" is-open="datepickers.searchDatehistory" readOnly id="searchDatehistory" name="searchDatehistory"/>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label">Territory</label>
                                                <div className="label-entries">
                                                    <select data-ng-model="selectTerritoryList"  >
                                                        <option value="" data-ng-selected="true"  selected>All territories</option>
                                                        <option data-ng-repeat="t in territoriesList" value="AU" >Australia (AU)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="BR" >Brazil (BR)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="BG" >Bulgaria (BG)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CA" >Canada (CA)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CL" >Chile (CL)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CN" >China (CN)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CO" >Colombia (CO)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="HR" >Croatia (HR)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CZ" >Czech Republic (CZ)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="DK" >Denmark (DK)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="EG" >Egypt (EG)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="EU" >Euro-Zone (EU)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="HK" >Hong Kong (HK)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="HU" >Hungary (HU)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="IN" >India (IN)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="ID" >Indonesia (ID)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="IL" >Israel (IL)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="JP" >Japan (JP)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="KZ" >Kazakhstan (KZ)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="LL" >Latin America and the Caribbean (LL)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="MY" >Malaysia (MY)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="MX" >Mexico (MX)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="NZ" >New Zealand (NZ)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="NG" >Nigeria (NG)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="NO" >Norway (NO)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="PE" >Peru (PE)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="PH" >Philippines (PH)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="PL" >Poland (PL)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="QA" >Qatar (QA)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="KR" >Republic of Korea (KR)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="WW" >Rest of World (WW)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="RO" >Romania (RO)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="RU" >Russia (RU)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="SA" >Saudi Arabia (SA)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="SG" >Singapore (SG)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="ZA" >South Africa (ZA)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="AP" >South Asia and Pacific (AP)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="SE" >Sweden (SE)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="CH" >Switzerland (CH)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="TW" >Taiwan (TW)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="TH" >Thailand (TH)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="TR" >Turkey (TR)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="AE" >United Arab Emirates (AE)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="GB" >United Kingdom (GB)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="TZ" >United Republic of Tanzania (TZ)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="US" >United States (US)</option>
                                                        <option data-ng-repeat="t in territoriesList" value="VN" >Vietnam (VN)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="box-footer">
                                <a className="icon-btn info" data-ng-click="searchFileHistory(searchDatehistory, selectTerritoryList);pageNumberFileHistory=1;">
                                    <i className="icon-search1"></i> Search
                                </a>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row-fluid">
                                <div className="table-responsive_big">
                                    <div className="alert alert-success " data-ng-hide="fileHistoryDetails.length &gt; 0">No file uploaded for this month, year and territory </div>
                                    <table className="table ng-hide" data-ng-show="fileHistoryDetails.length &gt; 0">
                                        <thead>
                                            <tr>
                                                <th>Year &amp; Month</th>
                                                <th>Territory</th>
                                                <th>Report</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                    
                                        </tbody>
                                    </table>
                                </div>
                                <div className="clearfix">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </Drawer>
    )
}
